import { create } from 'zustand';
import type { GridSortModel } from '@mui/x-data-grid';
import type {
  UserOnboarding,
  OnboardingStatus,
  FilterOption,
} from '../types';

interface OnboardingState {
  users: UserOnboarding[];
  isLoading: boolean;
  selectedOrgIds: string[];
  availableOrgs: FilterOption[];
  statusFilter: OnboardingStatus | null;
  searchQuery: string;
  sortModel: GridSortModel;

  setUsers: (users: UserOnboarding[]) => void;
  setLoading: (loading: boolean) => void;
  setSelectedOrgIds: (orgIds: string[]) => void;
  setAvailableOrgs: (orgs: FilterOption[]) => void;
  setStatusFilter: (status: OnboardingStatus | null) => void;
  setSearchQuery: (query: string) => void;
  setSortModel: (sortModel: GridSortModel) => void;
}

export const useOnboardingStore = create<OnboardingState>((set) => ({
  users: [],
  isLoading: false,
  selectedOrgIds: [],
  availableOrgs: [],
  statusFilter: null,
  searchQuery: '',
  sortModel: [{ field: 'lastActivity', sort: 'desc' }],

  setUsers: (users) => set({ users }),
  setLoading: (isLoading) => set({ isLoading }),
  setSelectedOrgIds: (selectedOrgIds) => set({ selectedOrgIds }),
  setAvailableOrgs: (availableOrgs) => set({ availableOrgs }),
  setStatusFilter: (statusFilter) => set({ statusFilter }),
  setSearchQuery: (searchQuery) => set({ searchQuery }),
  setSortModel: (sortModel) => set({ sortModel }),
}));
